import React, { useEffect } from 'react';
import buildsEnhancedMarkdownOverrides from '@resources/js/helpers/buildsEnhancedMarkdownOverrides';
import EnhancedMarkdown from '@resources/js/components/EnhancedMarkdown/EnhancedMarkdown';
import TabbedSelect from '@resources/js/components/TabbedSelect/TabbedSelect';
import VerticalContent from '@resources/js/components/VerticalContent/VerticalContent';
import { SelectListItem } from '@resources/js/typings/viewModels/selectListItemViewModel';
import useBuildsRotationFacets from '@resources/js/contexts/useBuildsRotationFacets';

export type BuildsRotationFacetsSectionViewModel = {
  title: string;
  description: string;
  facetOptions: SelectListItem<string>[];
};

export default function BuildsRotationFacetsSection({
  title,
  description,
  facetOptions,
}: BuildsRotationFacetsSectionViewModel): JSX.Element | null {
  const { facet, setFacet, setFacetOptions } = useBuildsRotationFacets();

  useEffect(() => {
    if (!facetOptions.length) {
      setFacet(undefined);
      return;
    }

    if (!facetOptions.some((x) => x.value === facet?.value)) {
      setFacet(facetOptions[0]);
    }
  }, [facet, facetOptions, setFacet]);

  useEffect(() => {
    setFacetOptions(facetOptions);
  }, [facetOptions, setFacetOptions]);

  if (!facetOptions.length) {
    return null;
  }

  return (
    <VerticalContent className='builds-rotation-facets-section'>
      <EnhancedMarkdown
        markdown={`
# ${title}

${description}
`}
        overrides={buildsEnhancedMarkdownOverrides}
      />
      <div className={'builds-rotation-facets-section__select-container'}>
        <TabbedSelect
          className={'builds-rotation-facets-section__desktop-select'}
          style={'v2'}
          value={facet ?? facetOptions[0]}
          onChange={(value) => setFacet(value)}
          options={facetOptions}
        />
        <TabbedSelect
          className={'builds-rotation-facets-section__mobile-select'}
          style={'v2'}
          isVertical
          value={facet ?? facetOptions[0]}
          onChange={(value) => setFacet(value)}
          options={facetOptions}
        />
      </div>
    </VerticalContent>
  );
}
